import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModerationComponent } from './moderation.component';
import {PanelModule} from 'primeng/panel';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {RouterModule, Routes} from '@angular/router';
import { ContenusModule } from './contenus/contenus.module';
import { FormsModule } from '@angular/forms'
import {InputSwitchModule} from 'primeng/inputswitch';
import { TableauComponent } from './component/tableau/tableau.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { BlockUIModule, DropdownModule, DynamicDialogModule, ProgressSpinnerModule, ToastModule } from 'primeng';
import { AffectationComponent } from './affectation/affectation.component';

@NgModule({
  declarations: [ModerationComponent, TableauComponent, AffectationComponent],
  imports: [
    CommonModule,
    PanelModule,
    TableModule,
    ButtonModule,
    RouterModule,
    ContenusModule,
    InputSwitchModule,
    FormsModule,
    MultiSelectModule,
    DynamicDialogModule,
    ToastModule,
    DropdownModule,
    BlockUIModule,
    ProgressSpinnerModule
  ],
  exports :[
    ModerationComponent
  ]
})
export class ModerationModule { }
